/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'warehouse': {
    width: 230,
    height: 188,
    viewBox: '0 0 230 188',
    data: '<defs/><path pid="0" id="warehouse" class="cls-1" d="M2358.22 262.327l-104.54-52.221a10.491 10.491 0 0 0-9.36 0l-104.54 52.221a10.448 10.448 0 0 0-5.78 9.343v20.888A10.449 10.449 0 0 0 2144.45 303h10.46v83.554A10.448 10.448 0 0 0 2165.36 397h167.28a10.448 10.448 0 0 0 10.45-10.444V303h10.46a10.449 10.449 0 0 0 10.45-10.442V271.67a10.448 10.448 0 0 0-5.78-9.343zm-77.86 51.12h-62.72V303h62.72v10.445zm-62.72 20.888h62.72v10.444h-62.72v-10.444zm0 31.333h62.72v10.444h-62.72v-10.444zm125.45-83.554h-10.45a10.453 10.453 0 0 0-10.46 10.444v83.554h-20.91v-83.554a10.451 10.451 0 0 0-10.45-10.444h-83.64a10.451 10.451 0 0 0-10.45 10.444v83.554h-20.91v-83.554a10.453 10.453 0 0 0-10.46-10.444h-10.45v-3.978l94.09-47 94.09 47v3.978z" transform="translate(-2134 -209)"/>'
  }
})
